module.exports = __webpack_public_path__ + "img/Menu-04.9f07cf2d.png";